<script lang="ts">
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        header: String,
        title: String,
        text: String,
        confirmText: {
            type: String,
            default: 't-ok'
        },
        cancelText: {
            type: String,
            default: 't-cancel'
        },
        warningText: String,
    },
    emits: ['update:modelValue', 'onCancel', 'onConfirm'],
    data() {
        return {
        }
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        }
    },
    methods: {
        confirm() {
            this.dialogShow = false;
            this.$emit('onConfirm')
        },
        cancel() {
            this.dialogShow = false;
            this.$emit('onCancel', 'cancel');
        },
        close() {
            this.dialogShow = false;
            this.$emit('onCancel', 'close');
        }
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="80%" height="50%" :close-on-back="false" persistent>
        <v-card class="big-dialog h-100 px-3">
            <v-toolbar density="compact">
                <v-toolbar-title>{{ header }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon="mdi-close" @click="close"></v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="d-flex flex-column align-center justify-center w-100 h-100 pb-0">
                <v-btn class="ma-2 icon-gradient" color="success" variant="text" :readonly="true" size="80">
                    <v-icon icon="mdi mdi-tooltip-question-outline" size="80"></v-icon>
                </v-btn>
                <p class="title">{{ title }}</p>
                <span class="text-describe">{{ text }}</span>
                <div v-if="warningText" class="d-flex align-center mt-2">
                    <v-icon icon="mdi mdi-alert-circle-outline" class="mr-1" color="warning"></v-icon>
                    <span class="warning-text">{{ warningText }}</span>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-container class="mx-0">
                    <div class="d-flex justify-end">
                        <v-btn @click="cancel" variant="outlined" color="primary" size="large">
                            {{ $t(cancelText) }}
                        </v-btn>
                        <v-btn @click="confirm" variant="flat" color="primary" size="large">
                            {{ $t(confirmText) }}
                        </v-btn>
                    </div>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>